import React from 'react';
import { Retailers } from 'components/retailers/Retailers';
import { RichText } from 'components/rich-text/RichText';

export const RetailersSlice = ({ tagline, title, text, hasText, items }) => {
  return (
    <Retailers tagline={tagline} title={title} text={hasText && RichText.render(text)}>
      {items?.map((item, index) => (
        <Retailers.Item
          key={index}
          link={item.link}
          label={item.label}
          title={item.title}
          image={item.image}
        />
      ))}
    </Retailers>
  );
};

export default RetailersSlice;
